function InputSelectOcupDisp({ value, setValue, label, current }) {

    // Opciones posibles
    const opciones = ["DISPONIBLE", "OCUPADA"];

    // Filtrar la opción que coincide con el estado actual
    const opcionesFiltradas = opciones.filter(op => op !== current);

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={value || ""}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value="" disabled>
                    Seleccione una opción
                </option>
                {opcionesFiltradas.map(op => (
                    <option key={op} value={op}>{op}</option>
                ))}
            </select>
        </div>
    );
}

export default InputSelectOcupDisp;